;
define("product_details_options_selector_pusher.tpl", function(){});

